/**
 * User Account API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ShareDto } from './shareDto';


export interface AdminShareRequestResponseDto { 
    id?: number;
    deviceId?: number;
    shareableName?: string;
    shareableType?: AdminShareRequestResponseDto.ShareableTypeEnum;
    requestedRole?: AdminShareRequestResponseDto.RequestedRoleEnum;
    requestedByUserAccountId?: number;
    requestedByEmail?: string;
    requestedAt?: string;
    inventaUsers?: Array<ShareDto>;
}
export namespace AdminShareRequestResponseDto {
    export const ShareableTypeEnum = {
        Animal: 'Animal',
        Camera: 'Camera',
        Collar: 'Collar',
        ConfigurationDevice: 'ConfigurationDevice',
        DataLogger: 'DataLogger',
        DropOff: 'DropOff',
        ExternalSensor: 'ExternalSensor',
        Trap: 'Trap',
        Tt4Sensor: 'TT4Sensor'
    } as const;
    export type ShareableTypeEnum = typeof ShareableTypeEnum[keyof typeof ShareableTypeEnum];
    export const RequestedRoleEnum = {
        Reader: 'READER',
        DataManager: 'DATA_MANAGER',
        Owner: 'OWNER',
        DeviceManager: 'DEVICE_MANAGER'
    } as const;
    export type RequestedRoleEnum = typeof RequestedRoleEnum[keyof typeof RequestedRoleEnum];
}


export type ShareableTypeEnum = typeof AdminShareRequestResponseDto.ShareableTypeEnum[keyof typeof AdminShareRequestResponseDto.ShareableTypeEnum];
export type RequestedRoleEnum = typeof AdminShareRequestResponseDto.RequestedRoleEnum[keyof typeof AdminShareRequestResponseDto.RequestedRoleEnum];
